import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportForm from "../common/support_form.js";
import IllumioSupportUtils from "../common/support_utils.js";
import IllumioDomUtils from "../common/dom_utils.js";
import { IllumioDate } from "../common/illumio_date.js";

export class TrainingSubscriptionListModel extends IllumioEventEmitter {
    constructor() {
        super();

        this.subscriptionAutomationEffectiveDate = null;
        this.subscriptionRecords = null;
        this.contactRecords = null;
        this.message = null;
    }

    /**
     * @param {*} theDataUrl 
     */
    loadTrainingSubscriptions(theDataUrl) {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', theDataUrl);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.addEventListener('load', this.trainingSubscriptionsLoadHandler.bind(this));
        xhr.addEventListener('error', this.trainingSubscriptionsErrorHandler.bind(this));
        xhr.send();
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    trainingSubscriptionsLoadHandler(event) {
        const xhr = event.currentTarget;
        if (xhr.status===200) {
            const data = JSON.parse(xhr.responseText);
            console.debug(data);

            this.subscriptionRecords = (data && data.subscription_assets && data.subscription_assets.assets) ? data.subscription_assets.assets : {};
            this.contactRecords = (data && data.subscription_assets && data.subscription_assets.contacts) ? data.subscription_assets.contacts : {};
            if (data && data.subscription_assets && data.subscription_assets.subscription_automation_effective_date) {
                this.subscriptionAutomationEffectiveDate = new Date(data.subscription_assets.subscription_automation_effective_date);
            }
            if (data && data.subscription_assets && data.subscription_assets.message) {
                this.message = data.subscription_assets.message;
            }
            
            console.debug(`trainingSubscriptionsLoadHandler(): Set subscription and contacts data`);
            console.debug(this.subscriptionAutomationEffectiveDate);
            console.debug(this.subscriptionRecords);
            console.debug(this.contactRecords);
            console.debug(this.message);
            this.emit('renderSubscriptionRecords', {});
        } else {
            console.warn(`trainingSubscriptionsLoadHandler(): Subscription record!`);
        }
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    trainingSubscriptionsErrorHandler(event) {
        console.error(`trainingSubscriptionsErrorHandler(): Loading subscription records fialed!`);
        console.debug(event);
        // TODO: Test this
    }

    /**
     * Assumption: The form is validated by JavaScript.
     * @param {*} theLearnerAssignmentForm
     */
    assignLearner(theLearnerAssignmentForm) {
        const csrf = IllumioSupportForm.getCsrf();
        const payload = {
            authenticity_token: (csrf) ? csrf['authenticity_token'] : null,
            sfdc_asset_id: theLearnerAssignmentForm['asset_id'].value,
            portal_user_type: 'content_user',
        }

        if (theLearnerAssignmentForm['previous_contact_id'].value) {
            payload['previous_contact_id'] = theLearnerAssignmentForm['previous_contact_id'].value;
        }
        
        if (theLearnerAssignmentForm['contact_id'].value.match(/^003/) && theLearnerAssignmentForm['contact_id'].value.length===18) {
            payload['sfdc_contact_id'] = theLearnerAssignmentForm['contact_id'].value;
        } else {
            payload['first_name'] = theLearnerAssignmentForm['first_name'].value;
            payload['last_name'] = theLearnerAssignmentForm['last_name'].value;
            payload['email'] = theLearnerAssignmentForm['email'].value;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('POST', theLearnerAssignmentForm.action);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.addEventListener('load', this.assignLearnerLoadHandler.bind(this));
        xhr.addEventListener('error', this.assignLearnerErrorHandler.bind(this));
        xhr.send(JSON.stringify(payload));
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    assignLearnerLoadHandler(event) {
        console.debug(`assignLearnerLoadHandler()`);
        const response = JSON.parse(event.currentTarget.response);
        console.debug(response);
        if (response.status<300) {
            const assetId = response.asset_id;
            const contactId = response.contact_id;
            // Update asset (subscription) record
            
            const subscriptionKeys = Object.keys(this.subscriptionRecords);
            console.debug(`assignLearnerLoadHandler(): subscriptionKeys: ${subscriptionKeys}`);
            console.debug(`assignLearnerLoadHandler(): » assetId: ${assetId}`);
            if (subscriptionKeys) {
                console.debug(`assignLearnerLoadHandler():   »»» exists in subscriptionKeys? ${subscriptionKeys.includes(assetId)}`);
            }

            console.debug(`assignLearnerLoadHandler(): assetId ${assetId} exists? ${Object.keys(this.subscriptionRecords)}`);
            if (this.subscriptionRecords[assetId]) {
                this.subscriptionRecords[assetId] = response.subscription;

                // Alternative
                // if (this.subscriptionRecords[assetId].learner_ids && this.subscriptionRecords[assetId].learner_ids.indexOf(contactId)<0) {
                //     this.subscriptionRecords[assetId].learner_ids.push(contactId);
                // }
                // this.subscriptionRecords[assetId].available_seat = this.subscriptionRecords[assetId].quantity - this.subscriptionRecords[assetId].learner_ids.length;
            } else {
                console.warn(`assignLearnerLoadHandler(): Unable to locate assetId [${assetId}] in this.subscriptionRecords!`);
            }
            
            // Update the contact record
            if (contactId && response.contact) {
                console.debug(`assignLearnerLoadHandler(): this.contactRecords[${contactId}]: BEFORE: ${JSON.stringify(this.contactRecords[contactId])}`);
                this.contactRecords[contactId] = response.contact;
                console.debug(`assignLearnerLoadHandler(): this.contactRecords[${contactId}]: AFTER: ${JSON.stringify(this.contactRecords[contactId])}`);
            }
            console.debug(`assignLearnerLoadHandler(): » Updated this.subscriptionRecords[${assetId}].learner_ids: ${JSON.stringify(this.subscriptionRecords[assetId])}`);
        }
        this.emit('displayAssignLearnerMessage', { response: response });
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    assignLearnerErrorHandler(event) {
        console.error(`assignLearnerErrorHandler(): Assigning learner failed`);
        console.debug(event);

        const xhr = event.curruentTarget;
        console.debug(event);
        console.debug(xhr);
        // TODO: Test this
        this.emit('displayAssignLearnerMessage', { response: JSON.parse(xhr.response) });
    }

    /**
     * @param {*} apiEndpoint 
     * @param {*} assetId 
     * @param {*} contactId 
     */
    unassignLearner(apiEndpoint, assetId, contactId) {
        const csrf = IllumioSupportForm.getCsrf();
        const payload = {
            authenticity_token: (csrf) ? csrf['authenticity_token'] : null,
            sfdc_asset_id: assetId,
            sfdc_contact_id: contactId,
        }

        const xhr = new XMLHttpRequest();
        xhr.open('DELETE', `${apiEndpoint}/${assetId}`);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.addEventListener('load', this.unassignLearnerLoadHandler.bind(this));
        xhr.addEventListener('error', this.unassignLearnerErrorHandler.bind(this));
        xhr.send(JSON.stringify(payload));
    }

    /**
     * If the unassign operation succeeds, udpate the data in the model.
     * ES6: Private method
     * @param {*} event 
     */
    unassignLearnerLoadHandler(event) {
        console.debug(`unassignLearnerLoadHandler()`);
        console.debug(event);
        const response = JSON.parse(event.currentTarget.response);
        if (response.status<300) {
            const assetId = response.asset_id;
            const contactId = response.contact_id;

            this.contactRecords[contactId] = response.contact;
            this.subscriptionRecords[assetId] = response.subscription;
        }
        this.emit('displayUnassignLearnerMessage', { response: response });
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    unassignLearnerErrorHandler(event) {
        console.debug(`unassignLearnerErrorHandler()`);
        console.debug(event);
        // TODO: Test this
        const xhr = event.currentTarget;
        this.emit('displayUnassignLearnerMessage', { response: JSON.parse(xhr.response) });
    }
}

export class TrainingSubscriptionListView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;

        this.theForm = document.getElementById('theTrainingSubscriptionForm');
        this.trainingSubscriptionsDiv = document.getElementById('trainingSubscriptions');
        this.trainingSubscriptionListDesktopTbody = document.querySelector('#trainingSubscriptionListDesktop tbody');
        if (this.trainingSubscriptionListDesktopTbody && 
                this.trainingSubscriptionListDesktopTbody.parentElement.previousElementSibling && 
                this.trainingSubscriptionListDesktopTbody.parentElement.previousElementSibling.classList.contains('spinning-icon')) {
            this.trainingSubscriptionSpinningIcon = this.trainingSubscriptionListDesktopTbody.parentElement.previousElementSibling;
        }
        this.assignLearnerModal = document.getElementById('assignLearnerModal');
        this.theLearnerAssignmentMessage = document.getElementById('theLearnerAssignmentMessage');
        this.theLearnerAssignmentFormContactFieldsElement = document.getElementById('contactFields');
        
        this.theLearnerAssignmentForm = document.getElementById('theLearnerAssignmentForm');
        this.theLearnerAssignmentForm.onsubmit = (event) => event.preventDefault();
        
        this.cancelAssignLearnerButton = document.getElementById('cancelAssignLearnerButton');
        this.cancelAssignLearnerButton.onclick = (event) => this.assignLearnerModal.close();

        this.assignLearnerButton = document.getElementById('assignLearnerButton');
        this.assignLearnerButton.onclick = this.assignLearnerButtonOnClickHandler.bind(this);

        this.subscriptionIntroductoryDiv = document.querySelector('#trainingSubscriptions #introductory');

        this.model.on('renderSubscriptionRecords', this.renderSubscriptionRecords.bind(this));
        this.model.on('displayAssignLearnerMessage', this.displayAssignLearnerMessage.bind(this));
        this.model.on('displayUnassignLearnerMessage', this.displayUnassignLearnerMessage.bind(this));

        if (this.theLearnerAssignmentForm) {
            console.debug(this.theLearnerAssignmentForm);
            for (let i=0;i<this.theLearnerAssignmentForm.elements.length;i++) {
                const theElement = this.theLearnerAssignmentForm.elements[i];
                if (theElement.required) {
                    theElement.onblur = (event) => {
                        const status = this.validate(event.currentTarget);
                        console.debug(`»»» status: ${status}`);
                    }
                } 
                if (theElement.required && (theElement.type==='select-one' || theElement.type==='checkbox')) {
                    theElement.onchange = (event) => { this.validate(event.currentTarget) }
                }
            }
        }
    }

    /**
     * If the input element is required and does not contain value, highlight error and return false. 
     * Otherwise, return true.
     * @param {*} inputElement 
     */
    validate(inputElement) {
        let isValid = true;
        let previousElement = null;
        let nextElement = null;

        if (inputElement) {
            console.debug(inputElement);
            console.debug(`validate(): ${inputElement.name}: ${inputElement.value} [${inputElement.type}]`);

            previousElement = inputElement.previousElementSibling;
            nextElement = inputElement.nextElementSibling;
            console.debug(previousElement);
            console.debug(nextElement);
        }

        if (inputElement && inputElement.required===true) {
            if (inputElement.type==='text' || inputElement.type==='email') {
                const contactIdElement = inputElement.form['contact_id'];
                if (contactIdElement && contactIdElement.value==='new') {
                    if (previousElement) {
                        previousElement.classList.remove('error');
                    }
                    if (nextElement) {
                        nextElement.classList.remove('error');
                        nextElement.classList.add('hidden');
                    }

                    if ((inputElement.type==='text' && !inputElement.value) || (inputElement.type==='email' && (!inputElement.value || !IllumioSupportForm.isValidEmail(inputElement.value)))) {
                        isValid = false;
                        if (previousElement) {
                            previousElement.classList.add('error');
                        }
                        if (nextElement) {
                            nextElement.classList.add('error');
                            nextElement.classList.remove('hidden');
                        }
                    }
                } else {
                    console.warn(`validate(): Missing contact_id select-one element!`);
                }

            } else if (inputElement.type==='select-one' && inputElement.name==='contact_id') {
                if (previousElement) {
                    previousElement.classList.remove('error');
                }

                if (this.theLearnerAssignmentFormContactFieldsElement) {
                    if (inputElement.value==='new') {
                        this.theLearnerAssignmentFormContactFieldsElement.classList.remove('hidden');
                        const contactFields = this.theLearnerAssignmentFormContactFieldsElement.querySelectorAll('input');
                        contactFields.forEach((element) => {
                            console.debug(`» contactFields.forEach(): element: ${element.name}`);
                            console.debug(element);
                            
                            const labelElement = element.previousElementSibling;
                            if (labelElement) {
                                labelElement.classList.remove('error');
                            }
                            const errorDivElement = element.nextElementSibling;
                            if (errorDivElement) {
                                errorDivElement.classList.remove('error');
                                errorDivElement.classList.add('hidden');
                            }
                        });
                    } else {
                        this.theLearnerAssignmentFormContactFieldsElement.classList.add('hidden');
                    }
                }

                if (inputElement.selectedIndex===0) {
                    if (previousElement) {
                        previousElement.classList.add('error');
                    }
                    isValid = false;
                }
            } else if (inputElement.type==='checkbox') {
                if (inputElement.checked===true && nextElement) {
                    nextElement.classList.remove('error');
                } else if (nextElement) {
                    nextElement.classList.add('error');
                    isValid = false;
                }
            }
        } else {
            console.debug(`validate(): inputElement is missing or not required!`);
        }

        console.debug(`validate(): isValid: ${isValid}`)

        return isValid;
    }

    /**
     * ES6: Private method
     */
    isTheLearnerAssignmentFormCompleted() {
        let invalidFieldCounter = 0;

        for (const elementName in this.theLearnerAssignmentForm.elements) {
            if (elementName.match(/^\d+$/) && !this.validate(this.theLearnerAssignmentForm[elementName])) {
                invalidFieldCounter++;
            }
        }

        console.debug(`isTheLearnerAssignmentFormCompleted(): invalidFieldCounter: ${invalidFieldCounter}`);

        return (invalidFieldCounter<=0) ? true : false;
    }

    /**
     * ES6: Private method
     */
    renderSubscriptionRecords() {
        console.debug(`renderSubscriptionRecords()`);
        if (this.trainingSubscriptionsDiv) {
            this.populateSubscriptionRecords();
        } else {
            console.warn(`renderSubscriptionRecords(): Missing trainingSubscriptionsDiv!`);
        }
    }

    /**
     * ES6: Private method
     * @param {*} args 
     */
    displayAssignLearnerMessage(args) {
        console.debug(`displayAssignLearnerMessage()`);
        console.debug(args);
        this.toggleAssignLearnerButton();
        if (args && args.response && args.response.status && args.response.message) {
            this.refreshAssetLearnerData(args.response.status, args.response.asset_id, args.response.subscription.available_seat); 
            this.displayMessage(this.theLearnerAssignmentMessage, args.response.message, args.response.status, true);
            this.theLearnerAssignmentForm.classList.add('hidden');
            this.cancelAssignLearnerButton.textContent = 'Close';
            this.assignLearnerButton.classList.add('hidden');
        } else {
            console.warn(`displayAssignLearnMessage(): Missing required response data for display!`);
        }
    }

    /**
     * ES6: Private method
     * @param {*} args 
     */
    displayUnassignLearnerMessage(args) {
        console.debug(`displayUnassignLearnerMessage()`);
        console.debug(args);
        if (args && args.response && args.response.status && args.response.message && args.response.asset_id) {
            this.refreshAssetLearnerData(args.response.status, args.response.asset_id, args.response.subscription.available_seat); 

            const elementId = `assetMessage-${args.response.asset_id}`;
            const messageElement = document.getElementById(elementId);
            if (messageElement) {
                this.displayMessage(messageElement, args.response.message, args.response.status, false);
            } else {
                console.warn(`displayUnassignLearnerMessage(): Missing display element ${elementId}`);
            }
        }
    }

    /**
     * General purpose function to display success 
     * @param {*} status 
     * @param {*} assetId 
     */
    refreshAssetLearnerData(status, assetId, availableSeatCount) {
        console.debug(`refreshAssetLearnerData(): status: ${status}`);
        console.debug(`refreshAssetLearnerData(): assetId: ${assetId}`);
        if (status<300) {
            let elementId = `learnerDataContainer-${assetId}`;
            const containerElement = document.getElementById(elementId);
            if (containerElement) {
                const assetRecord = this.model.subscriptionRecords[assetId];
                this.generateLearnersTable(assetRecord, containerElement);
            } else {
                console.warn(`refreshAssetLearnerData(): Missing containerElement by id ${elementId}`);
            }

            elementId = `assignLearner_${assetId}`;
            const assignButton = document.getElementById(elementId);
            // console.debug(assignButton);
            if (assignButton) {
                // assignButton.disabled = (availableSeatCount<=0) ? true : false;
                if (availableSeatCount>0) {
                    assignButton.disabled = false;
                    assignButton.classList.remove('hidden');
                } else {
                    assignButton.disabled = true;
                    assignButton.classList.add('hidden');
                }
            } else {
                console.warn(`refreshAssetLearnerData(): Missing assignButton by id ${elementId}`);
            }

            elementId = `availableSeat-${assetId}`;
            const availableSeatElement = document.getElementById(elementId);
            if (availableSeatElement) {
                availableSeatElement.textContent = availableSeatCount;
                console.debug(availableSeatElement);
            } else {
                console.warn(`refreshAssetLearnerData(): Missing availableSeatElement by id ${elementId}`);
            }
        }
    }

    /**
     * General purpose function to display operation result message in an element.
     * ES6: Private method
     * Assumption: Data exists.
     * @param {*} displayElement 
     * @param {*} message 
     * @param {*} status 
     */
    displayMessage(displayElement, message, status, ishiddenNextElement) {
        displayElement.textContent = message;
        displayElement.classList.remove('hidden');
        if (status<300) {
            displayElement.classList.remove('error');
            if (ishiddenNextElement) {
                const formInputElement = displayElement.nextElementSibling;
                if (formInputElement) {
                    formInputElement.classList.add('hidden');
                }
            }
        } else {
            displayElement.classList.add('error');
        }
    }

    /**
     * ES6: Private method
     */
    populateSubscriptionRecords() {
        if (this.model.subscriptionRecords && Object.keys(this.model.subscriptionRecords).length>0) {
            IllumioSupportUtils.emptyElement(this.trainingSubscriptionListDesktopTbody);

            let isDisplayTrainingSubscriptions = false;
            for (const [key, subscriptionRecord] of Object.entries(this.model.subscriptionRecords)) {
                const rowElement = document.createElement('tr');
                rowElement.id = `subscription_${subscriptionRecord['sfdc_asset_id']}`;
                const fields = [ 'subscription_start_date', 'subscription_end_date', 'quantity', 'available_seat', ]
                let subscriptionStartDate = null;
                let availableSeat = 0;
                for (let f=0;f<fields.length;f++) {
                    const columnElement = document.createElement('td');
                    if (fields[f]==='subscription_start_date' || fields[f]==='subscription_end_date') {
                        const date = new Date(subscriptionRecord[fields[f]]);
                        columnElement.textContent = IllumioSupportUtils.getUTCDisplayDate(date);
                        if (fields[f]==='subscription_start_date') {
                            subscriptionStartDate = date;
                        }
                    } else if (fields[f]==='quantity' || fields[f]==='available_seat') {
                        columnElement.textContent = subscriptionRecord[fields[f]];
                        columnElement.style.textAlign = 'center';
                        if (fields[f]==='available_seat') {
                            columnElement.id = `availableSeat-${subscriptionRecord['sfdc_asset_id']}`;
                            availableSeat = subscriptionRecord[fields[f]];
                        }
                    }
                    rowElement.appendChild(columnElement);
                }

                let isAddLearnerRow = false;
                const lastColumnElement = document.createElement('td');
                lastColumnElement.style.textWrapMode = 'nowrap';
                console.debug(`»»» availableSeat: [${availableSeat}]`);
                if (availableSeat.constructor===String) {
                    lastColumnElement.textContent = String.fromCodePoint(parseInt('00a0', 16));
                } else if (availableSeat>=0) {
                    const viewAnchor = document.createElement('a');
                    viewAnchor.href = '#';
                    viewAnchor.textContent = 'View';
                    viewAnchor.style.color = '#ff6600';
                    viewAnchor.style.padding = '0 0.375rem';
                    viewAnchor.dataset['asset_id'] = subscriptionRecord['sfdc_asset_id'];
                    viewAnchor.onclick = this.viewAnchorOnClickHandler.bind(this);
                    // TODO: Add tooltip
                    lastColumnElement.appendChild(viewAnchor);

                    const learnerExpandIcon = document.createElement('i');
                    learnerExpandIcon.id = `learnerExpandIcon_${subscriptionRecord['sfdc_asset_id']}`;
                    learnerExpandIcon.dataset['asset_id'] = subscriptionRecord['sfdc_asset_id'];
                    learnerExpandIcon.dataset['state'] = 'off';
                    learnerExpandIcon.classList.add('fa-solid');
                    learnerExpandIcon.classList.add('fa-greater-than');
                    learnerExpandIcon.classList.add('learner-expand-icon');
                    learnerExpandIcon.style.cursor = 'pointer';
                    learnerExpandIcon.style.color = '#ff6600';
                    // TODO: Add tooltip

                    const learnerExpandSpan = document.createElement('span');
                    learnerExpandSpan.style.fontSize = '1rem';
                    learnerExpandSpan.append(learnerExpandIcon);
                    learnerExpandSpan.onclick = this.expandIconOnClickHandler.bind(this);

                    lastColumnElement.appendChild(learnerExpandSpan);

                    isAddLearnerRow = true;
                }
                rowElement.append(lastColumnElement);
                this.trainingSubscriptionListDesktopTbody.append(rowElement);

                if (isAddLearnerRow) {
                    // Append an empty row as a workaround to table alternating colors
                    const emptyDataElement = document.createElement('td');
                    emptyDataElement.colSpan = 5;
                    const emptyRowElement = document.createElement('tr');
                    emptyRowElement.classList.add('hidden');
                    this.trainingSubscriptionListDesktopTbody.append(emptyRowElement);
                    
                    // Append the learner row. This row should have the same alternating background color as the corresponding subscription record.
                    const learnerDataElement = document.createElement('td');
                    learnerDataElement.colSpan = 5;
                    learnerDataElement.style.padding = '1.5rem';
                    this.populateLearnerRecords(learnerDataElement, subscriptionRecord);
                    console.debug(`» [${subscriptionRecord['sfdc_asset_id']}]: learner_ids: [${subscriptionRecord['learner_ids']}]`);
                    const learnerRowElement = document.createElement('tr');
                    learnerRowElement.classList.add('hidden');
                    learnerRowElement.appendChild(learnerDataElement);
                    this.trainingSubscriptionListDesktopTbody.append(learnerRowElement);
                }
                isDisplayTrainingSubscriptions = true;
            }

            if (isDisplayTrainingSubscriptions===true) {
                this.trainingSubscriptionsDiv.classList.remove('hidden');
                this.subscriptionIntroductoryDiv.classList.remove('hidden');
                if (this.trainingSubscriptionSpinningIcon) {
                    this.trainingSubscriptionSpinningIcon.style.display = 'none';
                }
            }
        } else {
            console.warn(`renderSubscriptionRecords(): Subscription record not detected!`);
            if (this.model.message) {
                this.subscriptionIntroductoryDiv.textContent = this.model.message;
                this.subscriptionIntroductoryDiv.classList.remove('hidden');
                this.trainingSubscriptionsDiv.classList.remove('hidden');
                this.theForm.classList.add('hidden');
            }
        }
    }

    /**
     * ES6: Private method
     * @param {*} learnerIds 
     */
    populateLearnerRecords(containerElement, assetRecord) {
        console.debug(`populateLearnerRecords()`);
        console.debug(containerElement);
        console.debug(assetRecord);

        if (containerElement && assetRecord && assetRecord['sfdc_asset_id'] && assetRecord['learner_ids']) {
            containerElement.appendChild(this.generateLearnersTable(assetRecord));
        } else {
            console.warn(`populateLearnerRecords(): containerElement and/or assetRecord of sfdc_asset_id and/or learner_ids are missing!`)
            console.debug(containerElement);
            console.debug(assetRecord);
        }

        const assignButton = document.createElement('button');
        const assetId = assetRecord['sfdc_asset_id'];
        assignButton.id = `assignLearner_${assetId}`;
        assignButton.classList.add('btn');
        assignButton.classList.add('btn-primary');
        assignButton.textContent = 'Assign';
        assignButton.dataset['asset_id'] = assetId;
        assignButton.style.float = 'right';
        assignButton.onclick = this.assignButtonOnClickHandler.bind(this);
        containerElement.appendChild(assignButton);

        console.debug(`populateLearnerRecords(): assetRecord['show_assign_button']: ${assetRecord['show_assign_button']} [${assetRecord['show_assign_button'].constructor}]`)
        if (assetRecord && assetRecord['show_assign_button']!==true) {
            assignButton.disabled = true;
            assignButton.classList.add('hidden');
        }
    }

    /**
     * Assumption: The assetRecord contains asset_id attribute.
     * ES6: Private method
     * @param {*} learnerIds 
     */
    generateLearnersTable(assetRecord, containerElement=null) {
        console.debug(`generateLearnersTable(): assetRecord: `);
        console.debug(assetRecord);

        let containerDivElement = null;
        if (containerElement) {
            containerDivElement = containerElement;
            IllumioDomUtils.removeChildren(containerDivElement);
        } else {
            containerDivElement = document.createElement('div');
            containerDivElement.id = `learnerDataContainer-${assetRecord['sfdc_asset_id']}`
        }

        const today = new IllumioDate().toISO8601CalendarDateString();
        console.debug(`genereateLearnersTable(): » ${assetRecord['subscription_start_date']} vs ${today}`);
        if (assetRecord['subscription_start_date']>today) {
            console.debug(`generateLearnersTable(): assetRecord['subscription_start_date']: [${assetRecord['subscription_start_date']}] vs [${today}]`);
            const spanElement = document.createElement('span');
            spanElement.textContent = 'Learner can be assigned on the start of the subscription effective date.';
            containerDivElement.appendChild(spanElement);

        } else if (assetRecord['learner_ids'].length>0) {
            const tbodyElement = document.createElement('tbody');
            assetRecord['learner_ids'].forEach(contactId => {
                const trElement = document.createElement('tr');
                const contactRecord = this.model.contactRecords[contactId];
                
                const fields = [ 'name', 'subscription_start_date', 'subscription_end_date', 'ilt_classes_taken' ];
                fields.forEach((field) => {
                    const tdElement = document.createElement('td');
                    if (field==='ilt_classes_taken') {
                        tdElement.style.textAlign = 'center';
                    }
                    if (field==='name') {
                        tdElement.textContent = `${contactRecord.first_name} ${contactRecord.last_name}`;
                    } else if (field.match(/_date$/)) {
                        tdElement.textContent = IllumioSupportUtils.getUTCDisplayDate(new Date(contactRecord[field]));
                    } else {
                        tdElement.textContent = contactRecord[field];
                    }
                    
                    trElement.appendChild(tdElement);
                });

                const tdElement = document.createElement('td');
                if (contactRecord.ilt_classes_taken===0 && contactRecord.is_active_subscriber===true) {
                    const reassignAnchorElement = document.createElement('a');
                    reassignAnchorElement.dataset['contact_id'] = contactRecord.sfdc_contact_id;
                    reassignAnchorElement.dataset['asset_id'] = assetRecord['sfdc_asset_id'];
                    reassignAnchorElement.textContent = 'Re-assign';
                    reassignAnchorElement.onclick = this.reassignLinkOnClickHandler.bind(this);
                    tdElement.appendChild(reassignAnchorElement);
                } else {
                    tdElement.textContent = '';
                }
                trElement.appendChild(tdElement);

                tbodyElement.appendChild(trElement);
            });

            const trElement = document.createElement('tr');
            const headers = [ 'Assigned Learner', 'Training Start Date', 'Training End Date', 'ILT Classes Taken', '' ]
            headers.forEach((header) => {
                const thElement = document.createElement('th');
                thElement.textContent = header;
                thElement.style.setProperty('background-color', '#a6a6a6', 'important');
                trElement.appendChild(thElement);
            });
            const theadElement = document.createElement('thead');
            theadElement.appendChild(trElement);
            const tableElement = document.createElement('table');
            tableElement.classList.add('ilo-tabular');
            tableElement.classList.add('desktop-view');
            tableElement.appendChild(theadElement);
            tableElement.appendChild(tbodyElement);
            
            const emailAnchorElement = document.createElement('a');
            emailAnchorElement.href = `mailto:training@illumio.com`;
            emailAnchorElement.textContent = `training@illumio.com`;

            const notePElement = document.createElement('p');
            notePElement.appendChild(document.createTextNode('To reassign used training seat, please contact '));
            notePElement.appendChild(emailAnchorElement);
            notePElement.appendChild(document.createTextNode('.'));

            const messageDivElement = document.createElement('div');
            messageDivElement.id = `assetMessage-${assetRecord['sfdc_asset_id']}`
            messageDivElement.classList.add('hidden');

            containerDivElement.appendChild(messageDivElement);
            containerDivElement.appendChild(tableElement);
            containerDivElement.appendChild(notePElement);
        } else {
            console.debug(`generateLearnersTable(): assetRecord['learner_ids']: ${assetRecord['learner_ids']} [${assetRecord['learner_ids'].constructor}]`);
            const spanElement = document.createElement('span');
            spanElement.textContent = 'No learner is assigned to this training subscription.';
            containerDivElement.appendChild(spanElement);
            
        }
        console.debug(`generateLearnersTable(): containerElement: `);
        console.debug(containerDivElement);

        return containerDivElement;
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    assignButtonOnClickHandler(event) {
        console.debug(`assignButtonOnClickHandler(): `);
        console.debug(event);
        event.preventDefault();
        
        const assetId = event.srcElement.dataset['asset_id'];
        this.updateTheLearnerAssignmentForm(assetId);
        this.theLearnerAssignmentForm.reset();
        this.theLearnerAssignmentFormContactFieldsElement.classList.add('hidden');
        if (this.theLearnerAssignmentForm['acknowledgment'].nextElementSibling) {
            this.theLearnerAssignmentForm['acknowledgment'].nextElementSibling.classList.remove('error');
        }

        const assetMessageElement = document.getElementById(`assetMessage-${assetId}`);
        if (assetMessageElement) {
            assetMessageElement.classList.add('hidden');
        }

        this.openAssignLearnerModal();
    }

    /**
     * ES6: Private method
     */
    openAssignLearnerModal() {
        this.theLearnerAssignmentForm.classList.remove('hidden');
        this.cancelAssignLearnerButton.textContent = 'Cancel';
        this.assignLearnerButton.classList.remove('hidden');
        this.assignLearnerModal.showModal();
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    reassignLinkOnClickHandler(event) {
        console.debug(`assignButtonOnClickHandler(): `);
        console.debug(event);
        event.preventDefault();
        
        const assetId = event.srcElement.dataset['asset_id'];
        const contactId = event.srcElement.dataset['contact_id'];
        console.debug(`reassignLinkOnClickHandler(): » assetId: ${assetId}`);
        console.debug(`reassignLinkOnClickHandler(): » contactId: ${contactId}`);
        // this.model.unassignLearner(this.theLearnerAssignmentForm.action, assetId, contactId);

        this.updateTheLearnerAssignmentForm(assetId, contactId);
        this.theLearnerAssignmentForm.reset();

        this.theLearnerAssignmentFormContactFieldsElement.classList.add('hidden');
        if (this.theLearnerAssignmentForm['acknowledgment'].nextElementSibling) {
            this.theLearnerAssignmentForm['acknowledgment'].nextElementSibling.classList.remove('error');
        }
        // this.assignLearnerButton.disabled = true;

        const assetMessageElement = document.getElementById(`assetMessage-${assetId}`);
        if (assetMessageElement) {
            assetMessageElement.classList.add('hidden');
        }

        this.openAssignLearnerModal();
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    assignLearnerButtonOnClickHandler(event) {
        console.debug(`assignLearnerButtonOnClickHandler()`);
        console.debug(event);

        event.preventDefault();
        this.theLearnerAssignmentMessage.classList.add('hidden');

        if (this.isTheLearnerAssignmentFormCompleted()) {
            this.toggleAssignLearnerButton();
            this.model.assignLearner(this.theLearnerAssignmentForm);
        }

    }

    /**
     * Toggle assignLearner button
     */
    toggleAssignLearnerButton() {
        if (this.assignLearnerButton.disabled===true) {
            this.assignLearnerButton.disabled = false;
            this.assignLearnerButton.classList.remove('btn-disabled');
        } else {
            this.assignLearnerButton.disabled = true;
            this.assignLearnerButton.classList.add('btn-disabled');
        }
    }

    /**
     * ES6: Private method
     * @param {*} assetId 
     */
    updateTheLearnerAssignmentForm(assetId, previousContactId=null) {
        console.debug(`updateTheLearnerAssignmentForm(): » assetId: ${assetId}`);
        console.debug(`updateTheLearnerAssignmentForm(): » previousContactId: ${previousContactId}`);
        this.theLearnerAssignmentForm['asset_id'].value = assetId;
        this.theLearnerAssignmentForm['previous_contact_id'].value = (previousContactId) ? previousContactId : '';

        this.theLearnerAssignmentMessage.textContent = '';
        this.theLearnerAssignmentMessage.classList.add('hidden');
        
        const contactIdSelect = this.theLearnerAssignmentForm['contact_id'];
        for (let i=contactIdSelect.options.length-1;i>0;i--) {
            contactIdSelect.remove(i);
        }

        console.debug(this.model.contactRecords);
        Object.keys(this.model.contactRecords).forEach((sfdcContactId) => {
            const item = this.model.contactRecords[sfdcContactId];
            console.debug(`» sfdcContactId: ${sfdcContactId}`);
            console.debug(item);
            
            let optionText = ``;

            if (item.first_name) { 
                optionText += item.first_name;
            }
            if (item.last_name) {
                if (optionText.length>0) { optionText += ' '; }
                optionText += item.last_name;
            }
            let isDisabled = false;
            if (item.subscription_end_date && item.is_active_subscriber) {
                optionText += ` (Active Subscription expires ${IllumioSupportUtils.getUTCDisplayDate(new Date(item.subscription_end_date))})`;
                isDisabled = true
            } else if (item.subscription_end_date) {
                optionText += ` (Subscription expired ${IllumioSupportUtils.getUTCDisplayDate(new Date(item.subscription_end_date))})`;
            }
            const optionElement = new Option(optionText, item.sfdc_contact_id);
            optionElement.disabled = isDisabled;
            contactIdSelect.add(optionElement);
        });
        
        const newContactOption = new Option('Add new contact', 'new');
        this.theLearnerAssignmentForm['contact_id'].add(newContactOption);
        console.debug(this.theLearnerAssignmentForm['contact_id']);

        this.theLearnerAssignmentMessage.textContent = '';
        const messageSiblingElement = this.theLearnerAssignmentMessage.nextElementSibling;
        if (messageSiblingElement) {
            messageSiblingElement.classList.remove('hidden');
        }
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    viewAnchorOnClickHandler(event) {
        event.preventDefault();

        const viewAnchorElement = event.currentTarget;
console.debug(`viewAnchorOnClickHandler()`);
console.debug(viewAnchorElement);
        if (viewAnchorElement.nextElementSibling) {
            console.debug(`viewAnchorOnClickHandler(): `);
            console.debug(viewAnchorElement.nextElementSibling);
            viewAnchorElement.nextElementSibling.click();
        }
    }

    /**
     * ES6: Private method
     * @param {*} event 
     */
    expandIconOnClickHandler(event) {
        const learnerExpandSpan = event.currentTarget;
        const parentTrElement = learnerExpandSpan.parentElement.parentElement;
        if (learnerExpandSpan.dataset['state']==='on') {
            learnerExpandSpan.dataset['state'] = 'off';
            if (learnerExpandSpan.childElementCount>0 && learnerExpandSpan.children[0].tagName==='svg') {
                learnerExpandSpan.children[0].classList.remove('learner-expand-icon-on');
                learnerExpandSpan.children[0].classList.add('learner-expand-icon-off');
            }
            // learnerExpandSpan.classList.add('learner-expand-icon-off');
            parentTrElement.nextSibling.nextSibling.classList.add('hidden');
            console.debug(`expandIconOnClickHandler(): Current status is [on] » changing to [off]`);
        } else {
            learnerExpandSpan.dataset['state'] = 'on';
            if (learnerExpandSpan.childElementCount>0 && learnerExpandSpan.children[0].tagName==='svg') {
                learnerExpandSpan.children[0].classList.remove('learner-expand-icon-off');
                learnerExpandSpan.children[0].classList.add('learner-expand-icon-on');
            }
            // learnerExpandSpan.classList.add('learner-expand-icon-on');
            parentTrElement.nextSibling.nextSibling.classList.remove('hidden');
            console.debug(`expandIconOnClickHandler(): Current status is [off] » changing to [on]`);
        }
    }
}

export class TrainingSubscriptionListController {
    constructor(model, view) {
        this.model = model;
        this.view = view;

        console.debug(this.view);
        if (this.view.theForm) {
            this.model.loadTrainingSubscriptions(this.view.theForm.action);
        }
    }
}
